import Duck from 'extensible-duck'
import { reportsEndPoints , reportScheduleEndpoints } from "../api/endpoints";
import moment from "moment";
import UserAuthentication from "./UserAuthentication";
import axios from "axios";
import toastr from "toastr";

const authenticationActions = UserAuthentication.creators;

export default new Duck({
  namespace: 'AuxoReports',
  store: 'reports',
  types: [
    'IS_LOADING',
    'LOGS',
    'JOB_LIST_FETCHED'
  ],
  initialState: {
    isLoading: false,
    logs: [],
    modal: false
  },
  reducer: (state, action, duck) => {
    switch (action.type) {
      case duck.types.IS_LOADING:
        return {
          ...state,
          isLoading: action.isLoading
        };
        case duck.types.JOB_LIST_FETCHED:
          return {
            ...state,
            reportScheduleList: action.reportScheduleList
          }
      case "LOGS":
        return {
          ...state,
          logs: action.payload
        }
      case "MODAL":
        return {
          ...state,
          modal: !state.modal
        }

      default:
        return state;
    }
  },
  selectors: {
    root: state => state
  },
  creators: (duck) => ({
    deleteReportSchedule: (id) => async (dispatch, getState) => {
      try {
        if (moment().isBefore(moment(getState().userAuthentication.user.exp))) {
          dispatch(authenticationActions.logoutUser());
          return;
        }
        
        dispatch({ type: duck.types.IS_LOADING, isLoading: true });
        
        await axios.delete(reportScheduleEndpoints.delete(id));
        dispatch({ type: duck.types.IS_LOADING, isLoading: false });
      }
      catch (e) {
        dispatch({ type: duck.types.IS_LOADING, isLoading: false });
        console.log('error', e);
      }

    },
    getReportScheduleList: () => async (dispatch, getState) => {
      try {
        if (moment().isBefore(moment(getState().userAuthentication.user.exp))) {
          dispatch(authenticationActions.logoutUser());
          return;
        }
        // if (getState().reportSchedule.isLoading) {
        //   // Don't issue a duplicate request (we already have or are loading the requested data)
        //   return;
        // }
        dispatch({ type: duck.types.IS_LOADING, isLoading: true });
        const { companyId } = JSON.parse(localStorage.getItem("companyInfo"));
        const response = await axios.get(reportScheduleEndpoints.list(companyId));
        console.log("in response" , response)
        const reportScheduleList = response.data;
        console.log("ioewjdio" , reportScheduleList)
        dispatch({ type: duck.types.JOB_LIST_FETCHED, reportScheduleList });
        dispatch({ type: duck.types.IS_LOADING, isLoading: false });

      }
      catch (e) {
        dispatch({ type: duck.types.IS_LOADING, isLoading: false });
        console.log('error', e);
      }
    },
    saveScheduleReport: (scheduleReport) => async (dispatch, getState) => {
      try {
        if (moment().isBefore(moment(getState().userAuthentication.user.exp))) {
          dispatch(authenticationActions.logoutUser());
          return;
        }
        if (getState().Reports.isLoading) {
          // Don't issue a duplicate request (we already have or are loading the requested data)
          return;
        }
        dispatch({ type: duck.types.IS_LOADING, isLoading: true });
        const { companyId } = JSON.parse(localStorage.getItem("companyInfo"));
        
        const { _id } = scheduleReport;
        if (_id) {
           await axios.put(reportScheduleEndpoints.reportWithId(_id), { ...scheduleReport, company: companyId });
        } else {
          await axios.post(reportScheduleEndpoints.basePath(), { ...scheduleReport, company: companyId });
        }
        dispatch({ type: duck.types.IS_LOADING, isLoading: false });
      }
      catch (e) {
        dispatch({ type: duck.types.IS_LOADING, isLoading: false });
        console.log('error', e);
      }

    },
    exportReport: (state) => async (dispatch, getState) => {

      if (moment().isBefore(moment(getState().userAuthentication.user.exp))) dispatch(authenticationActions.logoutUser());
        try {
        dispatch({ type: duck.types.IS_LOADING, isLoading: true });

        if (state.reportType === 'tripReport') {
          const response = await axios.post(reportsEndPoints.tripReport(),state);
          if(response.data.status === "success") {
            dispatch({type: "MODAL"});
          }
        }
        dispatch({ type: duck.types.IS_LOADING, isLoading: false });
      } catch (e) {
        dispatch({ type: duck.types.IS_LOADING, isLoading: false });
        throw e;
      }
    },
    fetchLogs: (state) => async(dispatch, getState) => {
      if (moment().isBefore(moment(getState().userAuthentication.user.exp))) dispatch(authenticationActions.logoutUser());
      const response = await axios.get(`${reportsEndPoints.fetchLogs()}`);
      dispatch({type: "LOGS", payload: response.data.data})
    },
    toggleModal: (state) => (dispatch, getState) => {
      if (moment().isBefore(moment(getState().userAuthentication.user.exp))) dispatch(authenticationActions.logoutUser());
      dispatch({type: "MODAL"})
    }

  })
})
